<template>
  <div class="login-page">
    <router-view />
  </div>
</template>

<script setup>
// 登录页面主入口
</script>

<style scoped>
.login-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>